import { useEffect, useState } from 'react';
import { useGetMathSkillReportMutation } from '../../../../../features/authentication/classesApiSlice';
import { useParams } from 'react-router';
import CustomToast from '../../../../../components/Toast';
import FERPA from '../../../../../components/FERPA/FerpaComponent';
import MathSkillReportOption from '../components/skillReportOption';
import Table from '../../../../assignments/pages/ManageAssign/components/StudentSessionReport/components/Table';
import { selectFerpaState } from '../../../../../features/authentication/authSlice';
import { useSelector } from 'react-redux';
import Skeleton from 'react-loading-skeleton';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import ProgressButton from '../../../../../components/ProgressButton';
import usePrintPdfGenerator from '../../../../../utils/PrintPdfGenerator';
import PageSize from '../../../../../enums/pageSize';

const MathSkillReport = () => {
  const [threshold, setThreshold] = useState(65);
  const [sessionReportOptions,setSessionReportOptions] = useState(
    {
      passingScore : threshold,
      renderOnly : true
    });
  const [mathSkillReport, setMathSkillReport] = useState({});
  const [getMathSkillReport] = useGetMathSkillReportMutation();

  const [levelTableExpand, setLevelTableExpand] = useState(true);
  const [topicTableExpand, settopicTableExpand] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  const [topicSkills, setTopicSkills] = useState([]);
  const [difficultyLevels, setDifficultyLevels] = useState([]);
  const ferpaEnabled = useSelector(selectFerpaState);
  const { studentId, courseId } = useParams();
  const { printPDF, isPdfGenerating } = usePrintPdfGenerator();

  useEffect(() => {
    getMathSkillReportAsync();
  }, []);

  useEffect(() => {
    updateSessionReportOptions();
  }, [threshold]);

  const updateSessionReportOptions = () => {
    setSessionReportOptions((prevOptions) => ({
      ...prevOptions,
      passingScore: threshold
    }));
  };
  const getMathSkillReportAsync = async () => {
    setIsLoading(true);
    const options = {
      studentId: studentId,
      courseId: courseId
    };
    const response = await getMathSkillReport(options);
    if (response.error) {
      if (response.error.data.errors)
        CustomToast(response.error.data.errors.Description, 'error');
      else
        CustomToast(response.error.data.error, 'error');
    } else {
      setMathSkillReport(response.data);
      setDifficultyLevels(response.data.difficultyLevels);
      setTopicSkills(response.data.topicSkills);
    }
    setIsLoading(false);
  };

  const handlePrint = async () => {
    if(isPdfGenerating) return;

    const contentWrapper = document.getElementById('mathskill-report');
    const htmlString = contentWrapper.innerHTML;

    const tempContainer = document.createElement('div');
    tempContainer.innerHTML = htmlString;

    const ferpaContainer = tempContainer.querySelector('#ferpaContainer');
    if (ferpaContainer) {
      ferpaContainer.classList.add('d-none');
    }

    const buttonElements = tempContainer.querySelectorAll('button');
    buttonElements.forEach((svgElement) => {
      svgElement.classList.add('d-none');
    });

    const svgElements = tempContainer.querySelectorAll('svg.svg-inline--fa');
    svgElements.forEach((svgElement) => {
      if (svgElement.classList.contains('fa-trophy-star')) {
        return;
      }
      svgElement.classList.add('d-none');
    });

    await printPDF('mathskill-report', tempContainer.innerHTML, PageSize.A3);
  };

  return (
    <div className="white-card" id='mathskill-report'>
      
      <div className='align-items-center d-flex justify-content-between'>
        <div>
          <h5>Skills Report</h5>
        </div>
        <div className='d-flex gap-3'>
          <div className='mt-2' id="ferpaContainer">
            <FERPA />
          </div>
          <button onClick={() => window.history.back()}
            className="btn btn-castleWhite btn-width cursor-pointer">
            Back
          </button>
          <ProgressButton
            isLoading={isPdfGenerating}
            onClick={handlePrint}
            loadingLabel="Generating PDF"
            label="Print to PDF"
            className="btn btn-castleRed"
          />
        </div>
      </div>
      {!isLoading && 
        <>
          <div className='align-items-center d-flex justify-content-between light-border-box p-3 mt-4 rounded-3'>
            <div>Student: <span className='fw-semibold'>{ferpaEnabled? mathSkillReport.studentName:'hidden'}</span></div>
            <div>Course: <span  className='fw-semibold'>{mathSkillReport.courseName}</span></div>
          </div>
          <div>
            <MathSkillReportOption
              threshold={threshold}
              setThreshold={setThreshold}
              score={mathSkillReport.totalScore}
              correct={mathSkillReport.correct}
              inCorrect={mathSkillReport.inCorrect}
            />            
          </div>
          {topicSkills && topicSkills.length > 0 &&
            <Table
              title="By Topic / Skill"
              setExpand={settopicTableExpand}
              expand={topicTableExpand}
              details={topicSkills}
              sessionReportOptions={sessionReportOptions}
              setUpdatedData={setTopicSkills}
              titleName="Topic / Skill"
            />
          }
          {difficultyLevels && difficultyLevels.length > 0 &&
            <Table
              title="By Difficulty Level"
              setExpand={setLevelTableExpand}
              expand={levelTableExpand}
              details={difficultyLevels}
              sessionReportOptions={sessionReportOptions}
              setUpdatedData={setDifficultyLevels}
              titleName="Level"
            />
          }
        </>
      }
      {isLoading &&
      <div className='w=100'>
        <div className='d-flex mt-5'>
          <div className='h-40 w-100'><Skeleton /></div>
          <div className='h-40 w-100'><Skeleton /></div>
        </div>
        <div className='d-flex mt-5 progress_bar_details'>
          <div className='h-40 w-100'><Skeleton /></div>
          <div className='h-40 w-100'><Skeleton /></div>
        </div>
        <table className='custom-table w-100 mt-5'>
          <TableSkeleton
            colCount={5}
            rowCount={3}
          />
        </table>
        <table className='custom-table w-100 mt-5'>
          <TableSkeleton
            colCount={5}
            rowCount={3}
          />
        </table>
      </div>}
    </div>
  );
};

export default MathSkillReport;